<template>
    <a-modal title="生成班级注册连接" :width="600" :visible="visible" :footer="null" @cancel="visible=false" :destroyOnClose="true">
      <p>班级：{{dept.departName}}</p>
      <p>注册后的角色：</p>
      <j-dict-select-tag
        type="list"
        v-model="roleCode"
        :trigger-change="true"
        @change="selectRole"
        dictCode="sys_role,role_name,role_code"
        placeholder="请选择注册后的角色"
        style="width: 200px"
      />
      <a-divider></a-divider>
      <p>班级注册连接：</p>
      <a-textarea :value="regLink" readOnly style="width: 100%"></a-textarea>
    </a-modal>
  </template>
  
  <script>
  import JDictSelectTag from '@/components/dict/JDictSelectTag'
  export default {
    name: 'DeptRegLink',
    components: {
      JDictSelectTag,
    },
    data() {
      return {
        visible: false,
        dept: {},
        departId: '',
        roleCode: 'student',
        regLink: '',
      }
    },
    created() {},
    watch:{
        departId(){
            this.getRegLink()
        }
    },
    methods: {
      show(dept) {
        this.dept = dept
        this.departId = dept.id
        this.visible = true
      },
      selectRole(v){
         this.roleCode = v
         this.getRegLink()
      },
      getRegLink() {
        this.regLink = window.location.protocol + '//' + window.location.host + '/user/register?departId=' 
        + this.departId + "&roleCode=" + this.roleCode
        return this.regLink
      },
    },
  }
  </script>
  
  <style>
  </style>